import { useNavigate } from "react-router-dom";
import type { ManagerSummary } from "../types/dashboard.types";
import { AvatarBadge } from "./AvatarBadge";

interface ManagersCardProps {
	managers: ManagerSummary[];
}

export function ManagersCard({ managers }: ManagersCardProps) {
	const navigate = useNavigate();

	return (
		<div className="crm-card">
			<div className="crm-card-head">
				<h3>Top menejerlar</h3>
				<span className="crm-badge blue">Bu oy</span>
			</div>
			<div className="crm-card-body compact">
				{managers.map((manager, index) => (
					<div
						className="crm-list-row"
						key={manager.id}
						onClick={() =>
							navigate("/sales", { state: { fromDashboard: true, manager: manager.name } })
						}
						style={{ cursor: "pointer" }}
					>
						<b className="crm-rank">{index + 1}</b>
						<AvatarBadge initials={manager.initials} tone={manager.tone} />
						<div>
							<strong>{manager.name}</strong>
							<span>{manager.salesCount}</span>
						</div>
						<em>{manager.amount}</em>
					</div>
				))}
			</div>
		</div>
	);
}
